import { getConstant } from '../utils';

export const getCalculatorsPreceding = getConstant('GET_CALCULATORS_PRECEDING');
export const getCalculatorsPrecedingItem = getConstant('GET_CALCULATORS_PRECEDING_ITEM');